import { render, staticRenderFns } from "./data-exports-layout.vue?vue&type=template&id=54fc0320"
import script from "./data-exports-layout.vue?vue&type=script&lang=js"
export * from "./data-exports-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports